import { render, staticRenderFns } from "./free-gifts-actions.vue?vue&type=template&id=8435e106"
import script from "./free-gifts-actions.vue?vue&type=script&lang=js"
export * from "./free-gifts-actions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports